
import Vue from 'vue';

// Assets
import Img1 from '~/assets/img/aon/1.png';
import Img2 from '~/assets/img/aon/2.png';
import Img3 from '~/assets/img/aon/3.png';
import Img4 from '~/assets/img/aon/4.png';

export default Vue.extend({
    name: 'AssessmentSection2',
    data: () => ({
        images: {
            1: Img1,
            2: Img2,
            3: Img3,
            4: Img4,
        },
    }),
});
